import Image from "next/image";
import { getReadableImageUrl } from "@/lib/directus";
import { sanitizeHTML } from "@/lib/utils";

interface LeftTextRightImageData {
  heading?: {
    text?: string;
    title?: string;
  };
  text?: {
    text?: string;
  };
  image?: {
    alt: string;
    image_file: {
      image: {
        id: string;
        filename_download: string;
      };
    };
  };
}

export const fields = [
  // heading
  "heading.text",
  "heading.title",
  
  // text
  "text.text",
  
  // image
  "image.alt",
  "image.image_file.image.id",
  "image.image_file.image.filename_download",
] as const;

interface LeftTextRightImageProps {
  data?: LeftTextRightImageData;
}

export default function LeftTextRightImage({ data }: LeftTextRightImageProps) {
  if (!data) return null;
  
  const imageUrl = data.image?.image_file?.image?.id 
    ? getReadableImageUrl(data.image.image_file.image.id, data.image.image_file.image.filename_download) 
    : '/images/dr-bader-talk-with-patient.png';
  
  const imageAlt = data.image?.alt || 'Image';
  
  return (
    <section className="w-full bg-white">
      <div className="max-w-screen-2xl mx-auto px-8 py-8 md:py-16">
          <div className="flex flex-col md:flex-row gap-8 md:gap-16 md:items-center">
          <div className="md:w-1/2">
            <h2 className="text-[2rem] font-essonnes font-light leading-tight md:text-5xl lg:text-[3.375rem] text-primary mb-8">
              {data.heading?.text || data.heading?.title || 'Every Nose Is Unique, Just Like Every Rhinoplasty Surgery'}
            </h2>
            {data.text?.text && (
              <div 
                className="text-[1rem] font-normal leading-normal md:text-xl text-primary font-greycliff md:leading-relaxed [&>p]:mb-4 [&>p:last-child]:mb-0 [&>*]:text-[1rem] [&>*]:font-normal [&>*]:leading-normal md:[&>*]:text-xl [&_a]:underline [&_a]:transition-all [&_a:hover]:no-underline"
                dangerouslySetInnerHTML={sanitizeHTML(data.text.text)}
              />
            )}
          </div>
          <div className="md:w-1/2 relative aspect-[844/780] bg-dark/40 rounded-lg">
            <Image
              src={imageUrl}
              alt={imageAlt}
              fill
              className="object-cover rounded-lg"
              sizes="(max-width: 768px) 100vw, 50vw"
              quality={90}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
} 
